import UITruncateString from 'UIComponents/text/UITruncateString';
import { PreviewCardHeaderWrapper, PreviewCardNameWrapper } from './PreviewCardStyles';
import PreviewCardTimestamp from 'svh-workspace-ui-lib/preview-card/public/components/PreviewCardTimestamp';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PreviewCardHeader = ({
  isUnread,
  isUnknownContact,
  text,
  renderAbsoluteTimestampOverride,
  timestamp,
  isNameHeader
}) => {
  return /*#__PURE__*/_jsxs(PreviewCardHeaderWrapper, {
    "data-test-id": "member-header",
    isUnread: isUnread,
    children: [isNameHeader ? /*#__PURE__*/_jsx(PreviewCardNameWrapper, {
      isUnread: isUnread,
      isUnknownContact: isUnknownContact,
      children: /*#__PURE__*/_jsx(UITruncateString, {
        tooltip: false,
        children: text
      })
    }) : /*#__PURE__*/_jsx(UITruncateString, {
      children: text
    }), /*#__PURE__*/_jsx("div", {
      className: "display-inline-flex align-center",
      children: timestamp ? /*#__PURE__*/_jsx(PreviewCardTimestamp, {
        renderAbsoluteTimestampOverride: renderAbsoluteTimestampOverride,
        timestamp: timestamp
      }) : null
    })]
  });
};
PreviewCardHeader.displayName = 'PreviewHeader';
export default PreviewCardHeader;